import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  USER_TOKEN_SET,
  TOKEN_INVALIDO,
  FECHA_MODULOS,
  SELECIONA_MODULOS  
} from "constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: localStorage.getItem('user_id'),
  token: JSON.parse(localStorage.getItem('token')),
  perfil: '',
  invalidToken: false,
  selecionarModulo: false,
  acessaPortaria: false,
  acessaBackOffice: false,
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNIN_USER_SUCCESS: {
      // acessaPortaria/acessaBackOffice/selecionarModulo eram calculados aqui a partir de
      // "configuracao" (backend legado). Agora quem decide isso é
      // sagas/Seguranca.js::decideRoteamentoModulo, a partir de GET /me da
      // Uzerpass.Seguranca — despacha SELECIONA_MODULOS/SELECIONA_MODULOS_PORTARIA/
      // IR_PARA_MODULO diretamente (ver docs/plano-integracao-api-seguranca.md).
      const retorno = action.payload;

      return {
        ...state,
        loader: false,
        authUser: retorno.authUser,
        perfil: 'Administrador',
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case FECHA_MODULOS: {
      return {
        ...state,
        selecionarModulo: false,
      }
    }
    case SELECIONA_MODULOS: {
      return {
        ...state,
        selecionarModulo: true,
      }
    }    
    case SIGNOUT_USER_SUCCESS: {

      return {
        ...state,
        authUser: null,
        token: null,
        initURL: '',
        loader: false,
        selecionarModulo: false
      }
    }
    case TOKEN_INVALIDO: {
      return {
        ...state,
        invalidToken: true
      }
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    default:
      return state;
  }
}
